"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UidMapBuilder = void 0;
var UidMapBuilder = /** @class */ (function () {
    function UidMapBuilder() {
        this.uidMap = {};
    }
    UidMapBuilder.prototype.addDefaultRows = function (rowData) {
        var _this = this;
        rowData.forEach(function (row, rowCount) {
            var _a;
            _this.uidMap[row.uid] = (_a = row.rowId) !== null && _a !== void 0 ? _a : rowCount;
        });
        return this;
    };
    UidMapBuilder.prototype.addDynamicRows = function (tableState) {
        var _this = this;
        tableState.forEach(function (row) {
            var uid = row === null || row === void 0 ? void 0 : row.uid;
            if (uid && uid.indexOf("dynamicRow_") > -1) {
                _this.incrementUidAndShift(uid, row.rowId);
            }
        });
        return this;
    };
    UidMapBuilder.prototype.removeRows = function (tableState) {
        var _this = this;
        tableState.forEach(function (row) {
            var uid = row === null || row === void 0 ? void 0 : row.uid;
            if (uid && (row === null || row === void 0 ? void 0 : row.dynamicallyRemoved)) {
                _this.uidMap[uid] = -1;
            }
        });
        return this;
    };
    UidMapBuilder.prototype.sortByValue = function () {
        var _this = this;
        var count = 0;
        var sortedUids = [];
        this.getUidKeys().forEach(function (uid) {
            var _a;
            sortedUids.push((_a = {}, _a[uid] = _this.uidMap[uid], _a));
        });
        sortedUids = sortedUids.sort(function (a, b) { return a[Object.keys(a)[0]] - b[Object.keys(b)[0]]; });
        sortedUids.forEach(function (uid) {
            var uidKey = Object.keys(uid)[0];
            if (_this.uidMap[uidKey] > -1) {
                _this.uidMap[uidKey] = count++;
            }
        });
        return this;
    };
    UidMapBuilder.prototype.create = function () {
        return this.uidMap;
    };
    UidMapBuilder.prototype.incrementUidAndShift = function (uid, rowId) {
        var _this = this;
        this.getUidKeys().forEach(function (uid) {
            if (_this.uidMap[uid] >= rowId) {
                _this.uidMap[uid]++;
            }
        });
        this.uidMap[uid] = rowId;
    };
    UidMapBuilder.prototype.getUidKeys = function () {
        return Object.keys(this.uidMap);
    };
    return UidMapBuilder;
}());
exports.UidMapBuilder = UidMapBuilder;
//# sourceMappingURL=UidMapBuilder.js.map